import axios from 'axios'
import config from '../config/dev.json'

let path = '/api/v1'
let url = config.host + path
let urlSecure = config.host + path +'/secure'
import production from '../config/production.json'
import Vue from 'vue';

if (process.env.NODE_ENV === 'production') {
  let url = config.host + path
  let urlSecure = config.host + path +'/secure'
}



export async function registerNewsletter(user){
  return new Promise((resolve, reject) => {
    axios.post(url + '/newsletter/register', user).then((response) => {
        console.log("response api", response.data.data)
        localStorage.token = response.data.data.token
        let token = localStorage.token;
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      resolve(response.data.data.user)
    }).catch(err => {
      let propsData = {
        direction: "right",
        duration: 1500
      }
      console.log('test err' , err.response.data.errors)
      Vue.prototype.$notif.show(
            (propsData = {
              title: "Error !",
              message: err.response.data.errors,
              type: "danger"
            })
          );
    })
  })
}





// WEBPACK FOOTER //
// ./src/api/newsletter.service.js